import { gql } from 'apollo-boost'
import { ID } from '../id.type'

export interface CreateQuoteDataEntry {
  id: ID
  status: string
  accessKey: string
}

export interface CreateQuoteData {
  quote: CreateQuoteDataEntry
}

export interface CreateQuoteVariables {
  code: string
  quote: {
    type: string
    paymentTerm: string
    person: {
      title?: string
      firstName: string
      lastName: string
      gender: string
      birthday: string
      email: string
      mobile: string
    }
    address: {
      street: string
      house?: string
      stairs?: string
      door?: string
      zipCode: string
      city: string
      riskAddress?: {
        street: string
        house?: string
        zipCode: string
        city: string
        ez: string
        gstnr: string
      }
    }
    building: {
      groundFloor: number
      firstFloor?: number
      secondFloor?: number
      mansarde?: number
      basement?: number
    }
    additional: {
      pool?: boolean
      horses?: number
      dogs?: number
      people?: {
        firstName: string
        lastName: string
        gender: string
        birthday: string
      }[]
      buildings?: {
        name: string
        area: number
      }[]
    }
  }
}

export const CREATE_QUOTE_MUTATION = gql`
  mutation start($code: ID!, $quote: CreateQuoteInput!) {
    quote: createQuote(code: $code, quote: $quote) {
      id
      status
      accessKey
    }
  }
`
